import * as React from "react";

function SvgComponent(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.203 3.333c.445.003 1.559.014 2.742.061l.42.019c1.19.055 2.38.152 2.972.316a2.342 2.342 0 011.615 1.685c.333 1.3.375 3.835.38 4.45v.271c-.005.614-.047 3.15-.38 4.45-.212.82-.831 1.466-1.615 1.684-.591.164-1.781.261-2.972.317l-.42.019a83.388 83.388 0 01-2.742.06H9.795c-.942-.005-4.88-.047-6.133-.396a2.344 2.344 0 01-1.615-1.685c-.334-1.3-.375-3.835-.38-4.449v-.272c.005-.614.046-3.15.38-4.449.211-.82.83-1.466 1.616-1.684 1.252-.35 5.191-.392 6.133-.397h.407zm-1.87 3.75v5.834l5-2.917-5-2.917z"
        fill={props.color ?? "#23262F"}
      />
    </svg>
  );
}

export default SvgComponent;
